<template>
  <el-popover trigger="click" placement="right"
              popper-class="bid-official-stock-detail-popover"
              v-if="stockInfos && stockInfos.length"
  >
    <table v-if="Array.isArray(stockInfos)">
      <tr class="header">
        <th v-for="key in Object.keys(stockInfos && stockInfos[0]||{})" :key="key">
          {{ key }}
        </th>
      </tr>
      <tr v-for="(row,idx) in stockInfos||[]" :key="idx">
        <td v-for="key in Object.keys(stockInfos[0]||{})" :key="key">
          <template v-if="typeof row[key] !== 'object'">{{ row[key] }}</template>
        </td>
      </tr>
    </table>
    <span v-else-if="typeof stockInfos === 'string'">{{ stockInfos }}</span>
    <i class="crm-icon-tips" slot="reference" style="font-size: 14px;cursor: pointer;"></i>
  </el-popover>
</template>
<script>
export default {
  props: {
    stockInfos: {
      type: Array,
      required: true,
      default () {
        return []
      }
    }
  }
}
</script>
<style lang="stylus">
  .bid-official-stock-detail-popover
    $border-style = 1px solid #cccccc
    min-width 350px
    table
      width 100%
      border $border-style
      text-align center
      .header
        background-color #e6e6e6
      tr
        border-bottom $border-style
        td, th
          padding 4px
          border-right $border-style
</style>
